<template>
  <layout-content>
    <i-button slot="top-buttons" size="large" type="primary" @click="create_internal">
      {{ $t('pbx.number.list.button.create_internal') }}
    </i-button>

    <table-component />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';
  import { NumberModalService } from '@pbx/modals/NumberModalService';
  import TableComponent from '@pbx/components/numbers/list/table';

  export default {
    components: {
      TableComponent
    },

    methods: {
      ...mapActions('pbx/numbers/table', ['getAsyncData']),

      create_internal: function() {
        NumberModalService.create_internal().on('success', () => this.getAsyncData());
      }
    }
  };
</script>
